<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">افزودن ترازو</strong>
                <strong v-else>ویرایش ترازو</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

                <strong v-if="status_form!=0">{{edit_name}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>
          <CRow>

            <CCol col="12">
              <CCardBody>
                <CRow>
                  <CCol col="3">
                    <CInput
                        label="نام ترازو"

                        v-model="name"
                        autocomplete="name"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="آی پی ترازو"

                        v-model="ip"
                        autocomplete="name"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="پورت"

                        v-model="port"
                        autocomplete="name"
                    />
                  </CCol>


                </CRow>

              </CCardBody>

            </CCol>
            <CCol col="12">
              <CRow >
                <CCol md="6">
                  <CCard>
                    <CCardHeader>
                      <strong>لیست ترازو ها</strong>
                    </CCardHeader>
                    <CCardBody>
                      <CDataTable
                          :items="items"
                          :fields="fields"
                          @row-clicked="table_row_clicked"

                          :items-per-page="10"
                          hover
                          sorter
                          striped
                          border
                          column-filter
                          pagination
                      >
                        <template #row="{item}">

                          <td style="text-align: center">
                            <p >{{ item.row_id + 1 }}</p>

                          </td>

                        </template>
                        <template #name="{item}">

                          <td>
                            <p >{{ item.brandName }}</p>

                          </td>

                        </template>


                        <template #operation="{item}">
                          <td>
<!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
<!--                                   name="cilApplications"/>-->

<!--                            <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                            <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                          </td>
                        </template>


                      </CDataTable>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>

            </CCol>

          </CRow>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_tarazo" + new Date().getTime() + "_" + this.$vnode.tag,
      edit_name:'',
      name: '',
      ip: '',
      port: '',
      items: [],
      table_clicks:0,
      table_clicks_timer:null,
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'tarazoName', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'tarazoIP', label: 'آی پی', _style: 'width:20%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:20%'},
        // {key: 'color', label: this.$t('tables.color'), _style: 'width:10%;'},
        {key: 'tarazoPort', label: 'پورت', _style: 'width:20%;'},
        {key: 'operation', label: "", filter: false, _style: 'width:10%;'},
      ],
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {

  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' ) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.edit_name = item.tarazoName;
      this.name = item.tarazoName;
      this.ip = item.tarazoIP;
      this.port = item.tarazoPort;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.ip = '';
      this.port = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    test_connection(item) {
//       // const socket = new WebSocket('ws://'+item.tarazoIP+':'+item.tarazoPort+'/');
//       const res = await fetch('http://'+item.tarazoIP+':'+item.tarazoPort+'/api/plu');
//       var pluList = await res.json();
// console.log("pluList",pluList)
    },
    get_lists() {
      var self = this;

      const formData = new FormData();

      axios.post('Tarazo/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_data() {
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "Tarazo/Add";
      } else {
        url = "Tarazo/Update";
        formData.append('id', this.status_form)
      }

      formData.append('TarazoName', this.name);
      formData.append('TarazoIP', this.ip);
      formData.append('TarazoPort', this.port);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        self.ip = '';
        self.port = '';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);
        bus.$emit('close_add_base_modal', 'false');

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "Tarazo/Delete";
      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
  }
}

</script>
